import _React, { useEffect, useState } from "react";

const useWindowHeight = () => {
	const [windowHeight, setWindowHeight] = useState(400);

	useEffect(() => {
		const updateWindowHeight = () => setWindowHeight(window.innerHeight);
		updateWindowHeight();
		window.addEventListener("resize", updateWindowHeight);
		return () => window.removeEventListener("resize", updateWindowHeight);
	}, []);

	return Math.min(windowHeight, 1440);
};

export default useWindowHeight;
